<template>
  <div ref="myEcharts" :style="{ height, width }"></div>
</template>
<script setup >
// props="['width','height','right1Data']"
import { ref, onMounted,defineProps,watchEffect } from "vue";
import * as echarts from "echarts";
const props =defineProps({
  width: {
    type: String,
    default: "100%",
  },
  height: {
    type: String,
    default: "100%",
  },
  listData: {
    type: Array,
    default: () => [],
  },
})
// console.log(props.leftData2);
const myEcharts = ref(null);

onMounted(() => {

  initChart(props.listData);
});


function initChart(listData) {
  if (myEcharts.value && myEcharts.value.chart) {
    myEcharts.value.chart.dispose();
  }

  const chartInstance = echarts.init(myEcharts.value);
// 数据信息
  var dataArr = [{
    value:listData.value,
    name: "",
    itemStyle: {
      normal: {
        lineStyle: {
          color: '#4A99FF',
          // shadowColor: '#4A99FF',
          // shadowBlur: 10,
        },
        shadowColor: '#4A99FF',
        shadowBlur: 10,
      },
    },
    areaStyle: {
      normal: { // 单项区域填充样式
        color: {
          type: 'linear',
          x: 0, //右
          y: 0, //下
          x2: 1, //左
          y2: 1, //上
          colorStops: [{
            offset: 0,
            color: '#4A99FF'
          }, {
            offset: 0.5,
            color: 'rgba(0,0,0,0)'
          }, {
            offset: 1,
            color: '#4A99FF'
          }],
          globalCoord: false
        },
        opacity: 1 // 区域透明度
      }
    }
  },

  ];
  var colorArr = ['#4A99FF', '#4BFFFC']; //颜
  const option= {
    color: colorArr,
    radar: {
      // shape: 'circle',
      name: {
        textStyle: {
          color: '#fff',
          fontSize: 26
        },
      },
      indicator: listData.list,
      splitArea: { // 坐标轴在 grid 区域中的分隔区域，默认不显示。
        show: true,
        areaStyle: { // 分隔区域的样式设置。
          color: ['rgba(255,255,255,0)', 'rgba(255,255,255,0)'], // 分隔区域颜色。分隔区域会按数组中颜色的顺序依次循环设置颜色。默认是一个深浅的间隔色。
        }
      },
      axisLine: { //指向外圈文本的分隔线样式
        lineStyle: {
          color: '#153269'
        }
      },
      splitLine: {
        lineStyle: {
          color: '#113865', // 分隔线颜色
          width: 1, // 分隔线线宽
        }
      },
    },
    series: [{
      type: 'radar',
      symbolSize: 8,
      // symbol: 'angle',
      data: dataArr
    }]
  };// 将你的ECharts配置项放在这里
  chartInstance.setOption(option);

}
window.addEventListener("resize", () => {
  chartInstance.resize();
});
function splitArray(array, size) {
  var result = Array.from({ length: Math.ceil(array.length / size) }, function(_, index) {
    return array.slice(index * size, index * size + size);
  });
  return result;
}
</script>
<style lang="less"></style>
